import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";

interface CircularProgressProps {
  progress: number;
  size?: number;
  strokeWidth?: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({ progress, size = 100, strokeWidth = 8 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  const primaryColor = useSelector((state: any) =>
    _.get(state.accounts, "item.theme.primaryColor", "#e51058"),
  );

  return (
    <svg width={`1rem`} height={`1rem`} viewBox={`0 0 ${size} ${size}`}>
      <defs>
        <linearGradient
          id="progressGradient"
          x1="0%"
          y1="50%"
          x2="100%"
          y2="50%"
        >
          <stop offset="0%" stopColor={primaryColor} />
          <stop offset="15%" stopColor={primaryColor} />
          <stop offset="44%" stopColor={primaryColor} />
          <stop offset="83%" stopColor={primaryColor} />
          <stop offset="100%" stopColor={primaryColor} />
        </linearGradient>
      </defs>

      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#eee"
        strokeWidth={strokeWidth}
        fill="none"
      />

      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="url(#progressGradient)"
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export default CircularProgress;